/***
 * @file: 
 * @author: xiaoyu.chen
 * @Date: 2025-08-13 16:51:04
 */
import { useStorage } from '@vueuse/core'
// import { extractStyle } from 'ant-design-vue/lib/_util/static-style-extract';
export default defineNuxtPlugin({
    name: 'my-plugin',
    enforce: 'pre', // 或 'post'
    async setup(nuxtApp) {
        // 这相当于一个普通功能插件
        const themeColor = ref<string>(<string>useState('themeColor').value || useCookie('themeColor').value || 'dark')

        nuxtApp.hook('app:rendered', (ctx) => {
            useHead(computed(() => {
                return {
                    htmlAttrs: {'data-theme': themeColor.value},
                }
            }))

            const config = useAppConfig()

            updateAppConfig({
                primaryColor: themeColor.value === 'dark' ? config.darkPrimary: config.lightPrimary
            })
        })
    },
    hooks: {
        // 您可以在这里直接注册 Nuxt 应用运行时钩子
        'app:created'() {
          const nuxtApp = useNuxtApp()
          // 在钩子中执行某些操作
          // console.log("app:created......", nuxtApp)
        },
        // 'app:mounted'() {
        //     const html = document.querySelector('html')
        //     console.log(html, '+++++++++++++++++++++++++===')
        // }
    },
    env: {
        // 如果您不希望插件在渲染仅服务器或岛屿组件时运行，请将此值设置为 `false`。
        islands: false
    }
})